module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAMAAADEfo0+AAAAUVBMVEUAAADHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8feA4WAAAAAGnRSTlMA++zl8eFbHng0MCjecWpkU006Jdiso39+Rr7NsLsAAABgSURBVBjTjdBZDoAgEANQ2RRU3Nfe/6D628YQ+eMlk+m0+vN2OzMEmIkgeZiapLVfMpJ0DhhI1gBkkuaVyNIDF8sGnJwH8DoTZU+UJFmTFbInuW7x+peGHAx3eLi7VPkDFWcFXs34oJgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right.png
// module id = SuS5
// module chunks = 1